import { useCallback } from 'react';
import { Card } from 'react-bootstrap';
import { Chain, ChainClient } from '../../../services/WebApiClient';
import { useClient } from '../../../util/useClient';
import { usePromise } from '../../EditorCommon/usePromise';
import { UserEditor } from '../UserEditor/UserEditor';
import { ChainProductLineAdmin } from './ChainProductLineAdmin';
import { CssAdmin } from './CssAdmin';
import { HostNameAdmin } from './HostNameAdmin';
import { LogoAdmin } from './LogoAdmin';
import { SettingsAdmin } from './SettingsAdmin';

export function SingleChainAdmin(props: {
    chain: Chain,
    onChange: () => void,
}) {

    const chainClient = useClient(ChainClient);
    const stores = usePromise(useCallback(async () => {

        const response = await chainClient.getStores(props.chain.id);
        return response.stores;

    }, [chainClient, props.chain.id]));

    return (
        <div className="container container-fluid" style={{ maxWidth: "100%" }}>
            <div className="row">
                
                <div className="col-md">
                    <Card>
                        <Card.Body>
                            <Card.Title>Hostnames</Card.Title>

                            <HostNameAdmin chain={props.chain} onChange={props.onChange} />
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Body>
                            <Card.Title>Product Lines</Card.Title>

                            <ChainProductLineAdmin chain={props.chain} onChange={props.onChange} />
                        </Card.Body>
                    </Card>

                    <Card>
                        <Card.Body>
                            <Card.Title>Logo</Card.Title>

                            <LogoAdmin chain={props.chain} onChange={props.onChange} />
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Body>
                            <Card.Title>CSS</Card.Title>

                            <CssAdmin chain={props.chain} onChange={props.onChange} />
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Body>
                            <Card.Title>Settings</Card.Title>

                            <SettingsAdmin  {...props} />
                        </Card.Body>
                    </Card>
                </div>
                <div className="col-md">
                    <Card>
                        <Card.Body>
                            <Card.Title>Users</Card.Title>
                            <UserEditor chainId={props.chain.id} stores={ stores } />
                        </Card.Body>
                    </Card>

                </div>
            </div>

        </div>
    );
}
